export default {"src":"/_next/static/media/alert-black.83bd7b73.svg","height":51,"width":51};